import { render, staticRenderFns } from "./QandABlock.vue?vue&type=template&id=716dc665"
import script from "./QandABlock.vue?vue&type=script&lang=js"
export * from "./QandABlock.vue?vue&type=script&lang=js"
import style0 from "./QandABlock.vue?vue&type=style&index=0&id=716dc665&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports